const Logo = ({ size = 'text-3xl' }) => {
  return (
    <h1
      className={`${size}`}
      style={{ fontFamily: "'Teko', sans-serif" }}
    >
      <span className='text-yellow-500'>The</span>
      <span className='text-white'>Champs</span>
    </h1>
  );
};

export default Logo;
